import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {Dropdown} from 'web-components';
import UpdateImpersonatePersonMutation from '../../mutations/mission_control/update_impersonate_person_mutation';
import MissionControlHeader from './mission_control_header';
import {cloneDeep} from 'lodash';
import Util from '../../forecast-app/shared/util/util';
import {hideLoader, showLoader} from '../global_loader';

class impersonate extends Component {
	constructor(props) {
		super(props);

		const sortedOtherPersons = cloneDeep(this.props.viewer.missionControlData.otherPersons).sort((a, b) => {
			if (a.companyName.toUpperCase() < b.companyName.toUpperCase()) return -1;
			if (a.companyName.toUpperCase() > b.companyName.toUpperCase()) return 1;
			return 0;
		});

		const longest_company_name = sortedOtherPersons.reduce(
			(total, el) => (total < el.companyName.length ? el.companyName.length : total),
			0
		);
		const longest_name = sortedOtherPersons.reduce(
			(total, el) => (total < `${el.firstName} ${el.lastName}`.length ? `${el.firstName} ${el.lastName}`.length : total),
			0
		);

		const padString = '                                                                               ';

		const permission_length = 30;

		let allOptions = sortedOtherPersons.map(op => {
			const value = op.id;
			const name = op.firstName + ' ' + op.lastName; //.replace(/ /g, '@42@');
			const profile = op.profileName;
			const label = `${(op.companyName + padString).substring(0, longest_company_name).replace(/ /g, '\u00a0')} ${(
				name + padString
			)
				.substring(0, longest_name)
				.replace(/ /g, '\u00a0')} ${(profile + padString).substring(0, permission_length).replace(/ /g, '\u00a0')} ${
				op.email
			}`.replace(/@42@/g, ' ');
			return {value: value, label: label, searchString: label.replace(/\u00a0/g, ' ')};
		});
		allOptions.unshift({
			value: 'none',
			label: `${('Company' + padString).substring(0, longest_company_name).replace(/ /g, '\u00a0')} ${('Name' + padString)
				.substring(0, longest_name)
				.replace(/ /g, '\u00a0')} ${('Permission' + padString)
				.substring(0, permission_length)
				.replace(/ /g, '\u00a0')} Email`,
		});

		const visibleOptions = allOptions.slice(0, 1000);
		this.props.viewer.missionControlData.forecastPersons.forEach(p => {
			if (
				p.impersonatedPersonId !== null &&
				p.impersonatedPersonId !== 'UGVyc29uOg==' &&
				!visibleOptions.some(v => v.value === p.impersonatedPersonId)
			) {
				const option = allOptions.find(a => a.value === p.impersonatedPersonId);
				visibleOptions.push(option);
			}
		});

		this.state = {
			showAllPersons: false,
			searchString: '',
			maxResults: 1000,
			sortedOtherPersons,
			longest_company_name,
			longest_name,
			allOptions,
			visibleOptions,
		};
	}

	onChange(personId, value) {
		showLoader();
		Util.CommitMutation(UpdateImpersonatePersonMutation, {
			id: personId,
			impersonatePerson: value === null || value.value.includes('none') ? null : value.value,
		});

		// Hubspot remove cookie
		document.cookie = 'hubspotutk=; Max-Age=-99999999;domain=.forecast.it;';
		document.cookie = '__hstc=; Max-Age=-99999999;domain=.forecast.it;';

		setTimeout(() => hideLoader(), 4000);
	}

	searchChanged(searchString) {
		console.log('searchChanged', searchString);
		clearTimeout(this.searchTimeout);
		this.searchTimeout = setTimeout(() => this.actualSearch(searchString), 500);
	}

	actualSearch(searchString) {
		let options = this.state.allOptions;

		if (searchString !== '') {
			options = options.filter(option => {
				return searchString.trim() === '' || this.normalizedIncludes(option.searchString, searchString.trim());
			});
		}

		options = options.slice(0, this.state.maxResults);
		if (searchString === '') {
			this.props.viewer.missionControlData.forecastPersons.forEach(p => {
				if (
					p.impersonatedPersonId !== null &&
					p.impersonatedPersonId !== 'UGVyc29uOg==' &&
					!options.some(v => v.value === p.impersonatedPersonId)
				) {
					const option = this.state.allOptions.find(a => a.value === p.impersonatedPersonId);
					options.push(option);
				}
			});
		}
		this.setState({visibleOptions: options});
	}

	normalizedIncludes(origin, searched) {
		if (origin == null || searched == null) return false;

		return origin
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.includes(
				searched
					.toLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
			);
	}

	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		if (!this.props.viewer.missionControlData.forecastPersons) {
			return null;
		}

		return (
			<div className="mission-control-list mission-control-impersonate">
				<MissionControlHeader viewer={this.props.viewer} />
				<h1>Impersonate another person</h1>
				<button onClick={() => this.setState({showAllPersons: !this.state.showAllPersons})}>Toggle all persons</button>
				<table>
					<tbody>
						{this.props.viewer.missionControlData.forecastPersons
							.filter(
								p =>
									this.state.showAllPersons ||
									this.props.viewer.actualPersonId === p.id ||
									p.impersonatedPersonId === this.props.viewer.actualPersonId
							)
							.map(p => {
								return (
									<tr key={p.id} className="people-list">
										<td className="name-row">
											<h3>{p.firstName}</h3>
										</td>
										<td>
											{/*<SelectInput
												locked={
													this.props.viewer.actualPersonId !== p.id &&
													p.impersonatedPersonId !== this.props.viewer.actualPersonId
												}
												options={options}
												onChange={this.onChange.bind(this, p.id)}
												value={p.impersonatedPersonId || null}
												clearable={false}
												label="Select person to impersonate"
												multi={false}
											/>*/}
											<div>Select person to impersonate</div>
											<Dropdown
												selectedItems={p.impersonatedPersonId ? [p.impersonatedPersonId] : []}
												name="Select"
												maxHeight={300}
												searchStringChangedCallback={searchString => this.searchChanged(searchString)}
												disabled={
													this.props.viewer.actualPersonId !== p.id &&
													p.impersonatedPersonId !== this.props.viewer.actualPersonId
												}
												onSelect={v => this.onChange(p.id, {value: v[0]})}
											>
												{this.state.visibleOptions.map((o, i) => {
													return (
														<Dropdown.SingleText
															key={i}
															value={o != null ? o.value : 'NA'}
															searchString={o != null ? o.searchString : 'NA'}
														>
															{o != null ? o.label : 'NA'}
														</Dropdown.SingleText>
													);
												})}
											</Dropdown>
										</td>
										<td className="remove-row">
											{this.props.viewer.actualPersonId === p.id ||
											p.impersonatedPersonId === this.props.viewer.actualPersonId ? (
												<button
													className="remove-button"
													onClick={this.onChange.bind(this, p.id, null)}
												>
													Clear Impersonation
												</button>
											) : null}
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</div>
		);
	}
}

const impersonateQuery = graphql`
	query impersonate_Query {
		viewer {
			actualPersonId
			component(name: "control_impersonate")
			...impersonate_viewer
		}
	}
`;

export {impersonateQuery};

export default createFragmentContainer(withRouter(impersonate), {
	viewer: graphql`
		fragment impersonate_viewer on Viewer {
			id
			...missionControlHeader_viewer
			actualPersonId
			missionControlData {
				id
				forecastPersons {
					id
					firstName
					lastName
					impersonatedPersonId
				}
				otherPersons {
					id
					firstName
					lastName
					email
					companyName
					profileName
				}
			}
		}
	`,
});
